<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ویرایش گروه کاربری</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect v-model="form.is_active.val" :description="form.is_active.inv" label="وضعیت"
                                    :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" 
                                    placeholder="انتخاب کنید" @change="form.is_active.val=$event.target.value" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CButton color="link" @click="all_selected" style="margin-left: 7px">انتخاب همه</CButton>
                                    <CButton color="link" @click="not_all_selected">هیچ کدام</CButton>
                                </CCol>
                            </CRow>
                            <br>
                            <CRow>
                                <CCol sm="12">
                                    <CTabs variant="pills">
                                        <CTab v-for="key in perm_array" :key="key.name" :title="key.name">
                                            <br>
                                            <CRow>
                                                <CCol sm="12">
                                                <CInputCheckbox v-for="option in key.fields" v-model="option.val"
                                                    true-value="true" false-value="false" :key="option.key"
                                                    :label="option.label" :checked="option.val === true"
                                                    @change="option.val = $event.target.checked"
                                                />
                                                </CCol>
                                            </CRow>
                                        </CTab>
                                    </CTabs>
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ویرایش</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
                name: {val: '', inv: '', v: { req: true, max: 64 }},
                is_active: {val: '', inv: '', v: {req: true, max: 8 }},
            },
            disable: false,
            perm_array: {
                black_lists: {
                    name: 'لیست سیاه',
                    fields: {
                        can_view_black_lists_page :{label: "مشاهده صفحه لیست سیاه", val: false},
                        can_view_black_lists :{label: "مشاهده شماره های لیست سیاه", val: false},
                        can_add_black_lists :{label: "افزودن یک شماره به لیست سیاه", val: false},
                        can_delete_black_lists :{label: "حذف یک شماره از لیست سیاه", val: false},
                        can_view_custom_black_lists_page: {label: 'مشاهده صفحه لیست سیاه اختصاصی', val: false},
                        can_view_custom_black_lists: {label: 'مشاهده شماره‌های لیست سیاه اختصاصی', val: false},
                        can_add_custom_black_lists: {label: 'افزودن شماره در لیست سیاه اختصاصی', val: false},
                        can_update_custom_black_lists: {label: 'ویرایش شماره در لیست سیاه اختصاصی', val: false},
                        can_delete_custom_black_lists: {label: 'حذف شماره از لیست سیاه اختصاصی', val: false},
                    }
                },
                conversations: {
                    name: 'پشتیبانی',
                    fields: {
                        can_view_user_conversations_page: {label: "مشاهده صفحه پشتیبانی ", val: false},
                        can_view_user_conversations: {label: "مشاهده مکالمه‌های پشتیبانی", val: false},
                        can_view_same_group_user_conversations: {label: "مشاهده مکالمه پشتیبانی کاربرهای هم‌گروه", val: false},
                        can_view_all_user_conversations: {label: "مشاهده مکالمه پشتیبانی همه کاربرها", val: false},

                        can_start_new_conversation: {label: "ایجاد مکالمه پشتیبانی جدید", val: false},
                        can_attach_file_in_all_user_conversations: {label: "افزودن فایل به پیام پشتیبانی", val: false},
                        can_attach_file_in_same_group_user_conversations: {label: "افزودن فایل به پیام پشتیبانی کاربرهای هم‌گروه", val: false},
                        can_attach_file_in_user_conversations: {label: "افزودن فایل به پیام پشتیبانی همه کاربرها", val: false},
                        can_make_all_user_conversations_close: {label: "بستن مکالمه پشتیبانی", val: false},
                        can_make_same_group_user_conversations_close: {label: "بستن مکالمه پشتیبانی کاربرهای هم‌گروه", val: false},
                        can_make_user_conversations_close: {label: "بستن مکالمه پشتیبانی همه کاربرها", val: false},
                        can_reply_all_user_conversations: {label: "ارسال پاسخ به پیام پشتیبانی", val: false},
                        can_reply_same_group_user_conversations: {label: "ارسال پاسخ به پیام پشتیبانی کاربرهای هم‌گروه", val: false},
                        can_reply_user_conversations: {label: "ارسال پاسخ به پیام پشتیبانی همه کاربرها", val: false},
                        can_user_update_last_user_messages_in_conversation: {label: "به‌روزرسانی پیام پشتیبانی خوانده نشده", val: false},
                        can_user_delete_last_user_messages_in_conversation: {label: "حذف پیام پشتیبانی خوانده نشده", val: false},
                    }
                },
                mobile_operator_model_perm: {
                    name: 'اپراتورها',
                    fields: {
                        can_view_mobile_operators_page: {label: "مشاهده صفحه اپراتورها", val: false},
                        can_view_mobile_operators: {label: "مشاهده اپراتورها", val: false},
                        can_add_mobile_operators: {label: "افزودن اپراتور ", val: false},
                        can_update_mobile_operators: {label: "بروزرسانی اپراتور", val: false},
                        can_delete_mobile_operators: {label: "حذف اپراتور", val: false},
                    }
                },
                operator_fee_model_perm: {
                    name: 'تعرفه‌ها',
                    fields: {
                        can_view_operator_fee_page: {label: "مشاهده صفحه تعرفه‌ها", val: false},
                        can_view_operator_fee: {label: "مشاهده تعرفه‌ها", val: false},
                        can_add_operator_fee: {label: "افزودن تعرفه", val: false},
                        can_update_operator_fee: {label: "به‌روزرسانی تعرفه", val: false},
                        can_delete_operator_fee: {label: "حذف تعرفه", val: false},
                        can_view_mobile_operators_fee_info: {label: "مشاهده جرئیات تعرفه‌ها", val: false},
                        can_add_mobile_operators_fee_info: {label: "افزودن جرئیات تعرفه", val: false},
                        can_update_mobile_operators_fee_info: {label: "به‌روزرسانی جرئیات تعرفه", val: false},
                        can_delete_mobile_operators_fee_info: {label: "حذف جرئیات تعرفه", val: false},
                    }
                },
                sms_gateway: {
                    name: 'درگاه‌ها',
                    fields: {
                        can_view_sms_gateway_page: {label: "مشاهده صفحه درگاه‌ها", val: false},
                        can_view_sms_gateway: {label: "مشاهده درگاه‌ها", val: false},
                        can_add_sms_gateway: {label: "افزودن درگاه", val: false},
                        can_update_sms_gateway: {label: "به‌روزرسانی درگاه", val: false},
                        can_delete_sms_gateway: {label: "حذف درگاه", val: false},
                    }
                },
                sms_messages: {
                    name: 'پیام‌ها',
                    fields: {
                        can_view_sms_message_page: {label: "مشاهده صفحه پیام‌ها", val: false},
                        can_view_sms_messages: {label: "مشاهده پیام‌ها", val: false},
                        can_view_all_user_sms_messages: {label: "مشاهده پیام‌های کاربرهای هم‌گروه", val: false},
                        can_view_same_group_user_sms_messages: {label: "مشاهده پیام‌های همه کاربرها", val: false},
                        can_view_inbox_sms_message_page: {label: "مشاهده صفحه پیام‌های دریافتی", val: false},
                        can_view_inbox_sms_messages: {label: "مشاهده پیام‌های دریافتی", val: false},
                        can_view_same_group_user_inbox_sms_messages: {label: "مشاهده پیام‌های دریافتی کاربرهای هم‌گروه", val: false},
                        can_view_all_user_inbox_sms_messages: {label: "مشاهده پیام‌های دریافتی همه کاربرها", val: false},
                        can_view_other_side_id: {label: "مشاهده other side ID", val: false},
                        can_send_sms_messages: {label: "ارسال پیام از طریق پنل", val: false},
                        can_send_same_group_user_sms_messages: {label: "ارسال پیام از اکانت کاربران هم گروه", val: false},
                        can_send_all_user_sms_messages: {label: "ارسال پیام از اکانت تمامی اعضا", val: false},
                        can_view_out_box_managment_page: {label: "مشاهده صفحه تعیین وضعیت پیام‌ها", val: false},
                        user_can_deny_user_sms: {label: "رد پیام‌ها", val: false},
                        user_can_deny_same_user_group_sms: {label: "رد پیام‌های کاربرهای هم‌گروه", val: false},
                        user_can_deny_all_user_sms: {label: "رد پیام‌های همه کاربرها", val: false},
                        user_can_accept_user_sms: {label: "تایید پیام‌ها", val: false},
                        user_can_accept_same_user_group_sms: {label: "تایید پیام‌های کاربرهای هم‌گروه", val: false},
                        user_can_accept_all_user_sms: {label: "تایید پیام‌های همه کاربرها", val: false},
                        can_user_download_message_in_csv_format: {label:"دانلود پیام‌ها با فرمت CSV", val: false}, 
                    }
                },
                user_billing_model_perms: {
                    name: 'امور مالی',
                    fields: {
                        can_view_bill_page: {label: "مشاهده صفحه صورتحساب‌ها", val: false},
                        view_my_bill: {label: "مشاهده صورتحساب‌ها", val: false},
                        view_same_group_user_bills: {label: "مشاهده صورتحساب‌های کاربرهای هم‌گروه", val: false},
                        view_all_user_bills: {label: "مشاهده صورتحساب‌های همه کاربرها ", val: false},         
                        can_add_bill: {label: "افزودن صورتحساب", val: false},
                        can_add_bill_for_all_users: {label: "افزودن صورتحساب کاربرهای هم‌گروه", val: false},
                        can_add_bill_for_same_group_users: {label: "افزودن صورتحساب همه کاربرها", val: false},
                        can_add_bill_type_add_increase_account_balance: {label: "افزودن صورتحساب (افزایش موجودی)", val: false},
                        can_add_bill_type_add_decrease_account_balance: {label: "افزودن صورتحساب (برداشت از موجودی)", val: false},
                        can_add_bill_type_add_pay_online: {label: "افزودن صورتحساب (پرداخت آنلاین)", val: false},
                        can_add_bill_type_add_fish: {label: "افزودن صورتحساب (ثبت فیش)", val: false},
                        can_pay_bill: {label: "پرداخت صورتحساب", val: false},
                        can_pay_bill_for_all_users: {label: "پرداخت صورتحساب کاربرهای هم‌گروه", val: false},
                        can_pay_bill_for_same_group_users: {label: "پرداخت صورتحساب همه کاربرها", val: false},
                        can_delete_bill: {label: "حذف صورتحساب", val: false},
                        can_delete_bill_for_all_users: {label: "حذف صورتحساب کاربرهای هم‌گروه", val: false},
                        can_delete_bill_for_same_group_users: {label: "حذف صورتحساب همه کاربرها", val: false},
                        can_verify_fish: {label: "تأیید فیش", val: false},
                        can_verify_fish_for_all_users: {label: "تأیید فیش کاربرهای هم‌گروه", val: false},
                        can_verify_fish_for_same_group_users: {label: "تأیید فیش همه کاربرها", val: false},
                    }
                },
                user_group_model_perm: {
                    name: 'گروه‌های کاربری',
                    fields: {
                        can_view_user_group_page: {label: "مشاهده صفحه گروه‌های کاربری", val: false},
                        can_view_user_group: {label: "مشاهده گروه‌های کاربری", val: false},
                        can_create_user_group: {label: "افزودن گروه کاربری", val: false},
                        can_update_user_group: {label: "به‌روزرسانی گروه کاربری", val: false},
                        can_delete_user_group: {label: "حذف گروه کاربری", val: false},
                        can_add_users_to_user_group: {label: "افزودن کاربر به گروه کاربری", val: false},
                        can_delete_users_from_user_group: {label: "حذف کاربر از گروه کاربری", val: false},
                    }
                },
                user_model_perm: {
                    name: 'کاربرها',
                    fields: {
                        can_view_user_info_page: {label: "مشاهده صفحه لیست کاربرها", val: false},
                        view_user_info: {label: "مشاهده اطلاعات کاربر", val: false},
                        view_same_group_users: {label: "مشاهده اطلاعات کاربرهای هم‌گروه", val: false},
                        view_all_users: {label: "مشاهده اطلاعات همه کاربرها", val: false},
                        can_add_user: {label: "افزودن کاربر", val: false},
                        update_user_info: {label: "به‌روزرسانی اطلاعات کاربر", val: false},
                        update_same_group_users: {label: "به‌روزرسانی اطلاعات کاربرهای هم‌گروه", val: false},
                        update_all_users: {label: "به‌روزرسانی اطلاعات همه کاربرها", val: false},
                        can_active_and_deactive_user: {label: "can active and deactive user", val: false},
                        delete_same_group_users: {label: "حذف کاربرهای هم‌گروه", val: false},
                        delete_all_users: {label: "حذف همه کاربرها", val: false},
                        can_verify_user: {label: "can verify user", val: false},
                        can_update_verified_user: {label: "can update verified user", val: false},
                        can_update_user_access_web_service_state: {label: "به‌روزرسانی دسترسی به ‌وب‌سرویس", val: false},
                        can_change_remembered_password: {label: "به‌روزرسانی رمز کاربر", val: false},
                        view_user_info_statistics: {label: "مشاهده آمار ارسال", val: false},
                        view_same_group_users_statistics: {label: "مشاهده آمار ارسال کاربرهای هم‌گروه ", val: false},
                        view_all_users_statistics: {label: "مشاهده آمار ارسال همه کاربرها", val: false},
                        can_recalculate_statistics_messages: {label: "توانایی محاسبه مجدد آمار ارسال پیام‌ها", val: false},
                    }
                },
                user_nums: {
                    name: 'شماره‌ها',
                    fields: {
                        can_view_user_nums_page: {label: "مشاهده صفحه شماره‌ها", val: false},
                        can_view_user_nums: {label: "مشاهده شماره‌ها", val: false},
                        can_view_same_group_users_nums: {label: "مشاهده شماره‌های کاربرهای هم‌گروه", val: false},
                        can_view_all_users_nums: {label: "مشاهده شماره‌های همه کاربرها", val: false},
                        can_add_user_nums: {label: "افزودن یک شماره جدید", val: false},
                        can_add_same_group_users_nums: {label: "افزودن یک شماره برای هر یک کاربران هم گروه", val: false},
                        can_add_all_users_nums: {label: "افزودن یک شماره جدید برای همه کاربران", val: false},
                        can_update_user_nums: {label: " بروزرسانی یک شماره ", val: false},
                        can_update_same_group_users_nums: {label: " بروزرسانی هر یک از شماره های کاربران هم گروه", val: false},
                        can_update_all_users_nums: {label: " بروزرسانی هر یک از شماره های کاربران ", val: false},
                        can_delete_user_nums: {label: "حذف یک شماره جدید", val: false},
                        can_delete_same_group_users_nums: {label: " حذف یک شماره از شماره های هر یک کاربران هم گروه", val: false},
                        can_delete_all_users_nums: {label: " حذف یک شماره از شماره های هر یک کاربران ", val: false},
                        can_add_link_to_nums: {label: "افزودن لینک به شماره", val: false},
                        can_add_link_to_nums_for_same_group_user: {label: "افزودن لینک به شماره کاربرهای هم‌گروه", val: false},
                        can_add_link_to_nums_for_all_user: {label: "افزودن لینک به شماره همه کاربرها", val: false},
                        can_remove_link_from_nums: {label: "حذف لینک از شماره", val: false},
                        can_remove_link_from_nums_for_same_group_user: {label: "حذف لینک از شماره کاربرهای هم‌گروه", val: false},
                        can_remove_link_from_nums_for_all_user: {label: "حذف لینک از شماره", val: false},
                        can_request_gateway_info: {label: "دسترسی کاربر به نام درگاه", val: false},
                        can_view_did_nums_page: {label: "مشاهده صفحه DIDs ", val: false},
                        can_view_did_nums: {label: "مشاهده DIDs", val: false},
                        can_add_did_nums: {label: "افزودن DID", val: false},
                        can_delete_did_nums: {label: "حذف DID", val: false},
                    }
                },
                user_tokens: {
                    name: 'توکن‌ها',
                    fields: {
                        can_view_tokens_page: {label: "مشاهده صفحه توکن‌ها", val: false},
                        view_my_tokens: {label: "مشاهده توکن‌ها", val: false},
                        view_same_group_user_tokens: {label: "مشاهده توکن‌های کاربرهای هم‌گروه", val: false},
                        view_all_user_tokens: {label: "مشاهده توکن‌های همه کاربرها", val: false},
                        can_add_token: {label: "افزودن توکن جدید", val: false},
                        can_add_token_for_same_group_users: {label: "افزودن توکن برای کاربرهای هم‌گروه", val: false},
                        can_add_token_for_all_users: {label: "افزودن توکن جدید برای همه کاربرها", val: false},
                        can_update_tokens: {label: "به‌روزرسانی توکن ", val: false},
                        can_update_tokens_for_same_group_users: {label: "به‌روزرسانی توکن کاربرهای هم‌گروه", val: false},
                        can_update_tokens_for_all_users: {label: "به‌روزرسانی توکن همه کاربرها", val: false},
                        can_delete_tokens: {label: "حذف توکن ", val: false},
                        can_delete_tokens_for_same_group_users: {label: "حذف توکن کاربرهای هم‌گروه", val: false},
                        can_delete_tokens_for_all_users: {label: "حذف توکن همه کاربرها", val: false},
                        can_disable_ip_check_for_token: {label: "غیرفعال کردن IP برای توکن", val: false},
                    }
                },
                user_links: {
                    name: 'لینک‌ها',
                    fields: {
                        can_view_link: {label: "مشاهده لینک‌ها", val: false},
                        can_view_link_for_same_group_user: {label: "مشاهده لینک‌های کاربرهای هم‌گروه", val: false},
                        can_view_link_for_all_users: {label: "مشاهده لینک‌ همه کاربرها", val: false},
                        can_add_link: {label: "افزودن لینک", val: false},
                        can_add_link_for_same_group_user: {label: "افزودن لینک برای کاربرهای هم‌گروه", val: false},
                        can_add_link_for_all_users: {label: "افزودن لینک برای همه کاربرها", val: false},
                        can_update_link: {label: "به‌روزرسانی لینک ", val: false},
                        can_update_link_for_same_group_user: {label: "به‌روزرسانی لینک کاربرهای هم‌گروه", val: false},
                        can_update_link_for_all_users: {label: "به‌روزرسانی لینک همه کاربرها", val: false},
                        can_remove_link: {label: "حذف لینک", val: false},
                        can_remove_link_for_same_group_user: {label: "حذف لینک کاربرهای هم‌گروه", val: false},
                        can_remove_link_for_all_users: {label: "حذف لینک همه کاربرها", val: false},
                    }
                },
                news: {
                    name: 'اطلاعیه‌ها',
                    fields: {
                        can_view_news: {label: "مشاهده اطلاعیه‌ها", val: false},
                        can_add_news: {label: "افزودن اطلاعیه", val: false},
                        can_delete_news: {label: "حذف اطلاعیه", val: false},
                    }
                },
                user_logs: {
                    name: 'لاگ‌ها',
                    fields: {
                        can_view_user_logs_page: {label: "مشاده صفحه لاگ‌ها", val: false},
                        can_view_user_logs: {label: "مشاهده لاگ‌ها", val: false},
                        can_view_user_logs_for_same_group_user: {label: "مشاهده لاگ‌های کاربرهای هم‌گروه", val: false},
                        can_view_user_logs_for_all_users: {label: "مشاهده لاگ‌های همه کاربرها", val: false},
                    }
                },
                audio_files: {
                    name: 'فایل‌های صوتی',
                    fields: {
                        can_view_audio_files_page: {label: "مشاهده صفحه فایل‌های صوتی", val: false},
                        can_view_user_audio_files: {label: "مشاهده فایل‌های صوتی", val: false},
                        can_view_user_audio_files_for_same_group_user: {label: "مشاهده فایل‌های صوتی کاربرهای هم‌گروه", val: false},
                        can_view_user_audio_files_for_all_users: {label: "مشاهده فایل‌های صوتی همه کاربرها", val: false},
                        can_add_user_audio_files: {label: "افزودن فایل صوتی", val: false},
                        can_add_user_audio_files_for_same_group_user: {label: "افزودن فایل صوتی برای کاربرهای هم‌گروه", val: false},
                        can_add_user_audio_files_for_all_users: {label: "افزودن فایل صوتی برای همه کاربرها", val: false},
                        can_play_user_audio_files: {label: "پخش فایل‌های صوتی", val: false},
                        can_play_user_audio_files_for_same_group_user: {label: "پخش فایل‌های صوتی کاربرهای هم‌گروه", val: false},
                        can_play_user_audio_files_for_all_users: {label: "پخش فایل‌های صوتی همه کاربرها", val: false},
                        can_delete_user_audio_files: {label: "حذف فایل‌های صوتی (یک نسخه در سرور می‌ماند)", val: false},
                        can_delete_user_audio_files_for_same_group_user: {label: "حذف فایل‌های صوتی کاربرهای هم‌گروه (یک نسخه در سرور می‌ماند)", val: false},
                        can_delete_user_audio_files_for_all_users: {label: "حذف فایل‌های صوتی همه کاربرها (یک نسخه در سرور می‌ماند)", val: false},
                    }
    
                },
                user_files: {
                    name: 'اسناد و مدارک',
                    fields: {
                        can_view_user_files_page: {label: "مشاهده صفحه اسناد و مدارک", val: false},
                        can_view_user_files: {label: " مشاهده اسناد و مدارک", val: false},
                        can_view_user_files_for_same_group_user: {label: "مشاهده اسناد و مدارک کاربرهای هم‌گروه", val: false},
                        can_view_user_files_for_all_users: {label: " مشاهده اسناد و مدارک همه کاربرها", val: false},
                        can_add_user_files: {label: "افزودن اسناد و مدارک", val: false},
                        can_add_user_files_for_same_group_user: {label: "افزودن اسناد و مدارک برای کاربرهای هم‌گروه", val: false},
                        can_add_user_files_for_all_users: {label: "افزودن اسناد و مدارک برای همه کاربرها", val: false},
                        can_download_user_files: {label: "دانلود اسناد و مدارک", val: false},
                        can_download_user_files_for_same_group_user: {label: "دانلود اسناد و مدارک کاربرهای هم‌گروه", val: false},
                        can_download_user_files_for_all_users: {label: "دانلود اسناد و مدارک همه کاربرها", val: false},
                        can_delete_user_files: {label: "حذف اسناد و مدارک", val: false},
                        can_delete_user_files_for_same_group_user: {label: "حذف اسناد و مدارک کاربرهای هم‌گروه", val: false},
                        can_delete_user_files_for_all_users: {label: "حذف اسناد و مدارک همه کاربرها", val: false},
                        can_accept_user_files: {label: "تعیین وضعیت اسناد و مدارک", val: false},
                        can_accept_user_files_for_same_group_user: {label: "تعیین وضعیت اسناد و مدارک کاربرهای هم‌گروه", val: false},
                        can_accept_user_files_for_all_users: {label: "تعیین وضعیت اسناد و مدارک همه کاربرها", val: false}, 
                    }
                },
                monitoring: {
                    name: 'مونیتورینگ',
                    fields: {
                        can_view_monitoring_page: {label: 'مشاهده صفحه مونیتورینگ', val: false},
                        can_view_user_send_rcv_into_data: {label: 'مشاهده اطلاعات ارسال و دریافت کاربر', val: false},
                        can_view_same_group_user_send_rcv_into_data: {label: 'مشاهده اطلاعات ارسال و دریافت کاربرهای هم‌گروه', val: false},
                        can_view_all_user_send_rcv_into_data_for_all_users: {label: 'مشاهده اطلاعات ارسال و دریافت همه کاربرها', val: false},
                        can_view_system_logs_over_ws: {label: 'مشاهده نوتیفیکیشن در پنل کاربری', val: false},
                        can_view_user_logs_over_ws: {label: 'مشاهده نوتیفیکیشن کاربر', val: false},
                        can_view_same_user_groups_logs_over_ws: {label: 'مشاهده نوتیفیکیشن کاربرهای هم‌گروه', val: false},
                        can_view_all_user_logs_over_ws: {label: 'مشاهده نوتیفیکیشن همه کاربرها', val: false},
                    }
                },
                out_box_gradual_sms:{
                    name: 'پیام‌های تدریجی',
                    fields:{
                        can_view_out_box_gradual_sms_page: {label: 'مشاهده صفحه پیام‌های تدریجی', val: false},
                        can_view_out_box_gradual_sms_group: {label: 'مشاهده پیام‌های تدریجی', val: false},
                        can_view_out_box_gradual_sms_group_for_same_group_users: {label: 'مشاهده پیام‌های تدریجی کاربرهای هم‌گروه', val: false},
                        can_view_out_box_gradual_sms_group_for_all_users: {label: 'مشاهده پیام‌های تدریجی همه کاربرها', val: false},
                        can_add_out_box_gradual_sms_group: {label: 'افزودن پیام تدریجی', val: false},
                        can_add_out_box_gradual_sms_group_for_same_group_users: {label: 'افزودن پیام تدریجی کاربرهای هم‌گروه', val: false},
                        can_add_out_box_gradual_sms_group_for_all_users: {label: 'افزودن پیام تدریجی همه کاربرها', val: false},
                        can_update_out_box_gradual_sms_group: {label: 'ویرایش پیام تدریجی', val: false},
                        can_update_out_box_gradual_sms_group_for_same_group_users: {label: 'ویرایش پیام تدریجی کاربرهای هم‌گروه', val: false},
                        can_update_out_box_gradual_sms_group_for_all_users: {label: 'ویرایش پیام تدریجی همه کاربرها', val: false},
                        can_delete_out_box_gradual_sms_group: {label: 'حذف پیام تدریجی', val: false},
                        can_delete_out_box_gradual_sms_group_for_same_group_users: {label: 'حذف پیام تدریجی کاربرهای هم‌گروه', val: false},
                        can_delete_out_box_gradual_sms_group_for_all_users: {label: 'حذف پیام تدریجی همه کاربرها', val: false},
                        can_view_out_box_gradual_sms_rcv_number_page: {label: 'مشاهده صفحه گیرنده‌ها ', val: false},
                        can_view_out_box_gradual_sms_rcv_numbers: {label: 'مشاهده گیرنده‌ها', val: false},
                        can_view_out_box_gradual_sms_rcv_numbers_for_same_group_users: {label: 'مشاهده گیرنده‌های کاربرهای هم‌گروه', val: false},
                        can_view_out_box_gradual_sms_rcv_numbers_for_all_users: {label: 'مشاهده گیرنده‌های همه کاربرها', val: false},
                        can_add_out_box_gradual_sms_rcv_numbers: {label: 'افزودن گیرنده‌ها', val: false},
                        can_add_out_box_gradual_sms_rcv_numbers_for_same_group_users: {label: 'افزودن گیرنده‌های کاربرهای هم‌گروه', val: false},
                        can_add_out_box_gradual_sms_rcv_numbers_for_all_users: {label: 'افزودن گیرنده‌های همه کاربرها', val: false},
                        can_delete_out_box_gradual_sms_rcv_numbers: {label: 'حذف گیرنده‌ها', val: false},
                        can_delete_out_box_gradual_sms_rcv_numbers_for_same_group_users: {label: 'حذف گیرنده‌های کاربرهای هم‌گروه', val: false},
                        can_delete_out_box_gradual_sms_rcv_numbers_for_all_users: {label: 'حذف گیرنده‌های همه کاربرها', val: false},
                        can_view_out_box_gradual_sms_send_sequence_page: {label: 'مشاهده صفحه روندها', val:false},
                        can_view_out_box_gradual_sms_send_sequences: {label: 'مشاهده روندها', val:false},
                        can_view_out_box_gradual_sms_send_sequences_for_same_group_users: {label: 'مشاهده روندهای کاربرهای هم‌گروه', val:false},
                        can_view_out_box_gradual_sms_send_sequences_for_all_users: {label: 'مشاهده روندهای همه کاربرها', val:false},
                        can_add_out_box_gradual_sms_send_sequences: {label: 'افزودن روندها', val:false},
                        can_add_out_box_gradual_sms_send_sequences_for_same_group_users: {label: 'افزودن روندهای کاربرها هم‌گروه', val:false},
                        can_add_out_box_gradual_sms_send_sequences_for_all_users: {label: 'افزودن روندهای همه کاربرها', val:false},
                        can_update_out_box_gradual_sms_send_sequences: {label: 'به‌روزرسانی روند', val:false},
                        can_update_out_box_gradual_sms_send_sequences_for_same_group_users: {label: 'به‌روزرسانی روند کاربرهای هم‌گروه', val:false},
                        can_update_out_box_gradual_sms_send_sequences_for_all_users: {label: 'به‌روزرسانی روند همه کاربرها', val:false},
                        can_delete_out_box_gradual_sms_send_sequences: {label: 'حذف روند', val:false},
                        can_delete_out_box_gradual_sms_send_sequences_for_same_group_users: {label: 'حذف روند کاربرهای هم‌گروه', val:false},
                        can_delete_out_box_gradual_sms_send_sequences_for_all_users: {label: 'حذف روند همه کاربرها', val:false},
                    }
                }
            }
        }
    },
    mounted(){
        this.get_user_group();
    },
    methods: {
        all_selected(){
            for (const key in this.perm_array){
                for (const k in this.perm_array[key].fields){
                    this.perm_array[key].fields[k].val = true;
                }
            }
        },
        not_all_selected(){
            for (const key in this.perm_array){
                for (const k in this.perm_array[key].fields){
                    this.perm_array[key].fields[k].val = false;
                }
            }
        },
        get_user_group(){
            this.axios.get('user_groups/'
                + '?perm_array=1'
                + '&id=' + this.$route.params.id)
                .then(res => {
                    this.form.name.val = res.data[0].name;
                    this.form.is_active.val = `${res.data[0].is_active}`;
                    for (const key in this.perm_array){
                        for (const k in res.data[0].perm_array){
                            if(key == k){
                                for (const key2 in this.perm_array[key].fields){
                                    for (const k2 in res.data[0].perm_array[k]){
                                        if(key2 == k2){
                                            this.perm_array[key].fields[key2].val = res.data[0].perm_array[k][k2];
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                data.set('id', this.$route.params.id);
                for (const key in this.perm_array){
                    for (const k in this.perm_array[key].fields){
                        data.set(k, this.perm_array[key].fields[k].val);
                    }
                }
                this.axios.put('user_groups/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ویرایش با موفقیت انجام شد.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_update_user_group == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
